import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { isEmpty } from 'utils/validations'
import ContentHeader from 'component/utils/ContentHeader'
import ApproversEditForm from 'component/usageConsumptionApprovers/EditForm'
import UsageConsumptionApproversTable from 'component/usageConsumptionApprovers/Table'
import Notification from 'component/utils/Notification'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'
import { ToastContainer } from 'react-toastify'
import { renderToastSuccessMsg, renderToastWarn } from 'utils/ToastUtils'

import * as usageConsumptionApproversActions from 'action/usageConsumptionApprovers'

class UsageConsumptionApproversContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    error: PropTypes.object,
    updated: PropTypes.bool,
    removed: PropTypes.bool,
    menuMissions: PropTypes.array.isRequired,
    update: PropTypes.func.isRequired,
    fetchUsageConsumptionApprovers: PropTypes.func.isRequired,
    getMenuMission: PropTypes.func.isRequired,
    resetEditMenuMissions: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    success: PropTypes.string.isRequired,
    clearSuccessMessage: PropTypes.func.isRequired,
    resetSave: PropTypes.func,
    fetchMissionsOptions: PropTypes.func,
    options: PropTypes.array,
  }

  constructor(props) {
    super(props)

    this.state = {
      formVisible: true,
      tableVisible: true,
      renderButtons: false,
      updateOptions: false,
    }
  }

  componentDidMount() {
    const {
      fetchUsageConsumptionApprovers,
      fetchMissionsOptions,
      auth: { user },
    } = this.props

    fetchMissionsOptions(user.dsToken)
    fetchUsageConsumptionApprovers(user.dsToken)
  }

  componentWillUnmount() {
    const { resetEditMenuMissions, resetSave } = this.props

    resetEditMenuMissions()
    resetSave()
  }

  componentWillReceiveProps() {
    const { formVisible } = this.state
    const { updated } = this.props

    if (formVisible && updated) {
      this.invertStates()
    }
  }

  componentDidUpdate(prevProps) {
    const { clearSuccessMessage, error, success, translate } = this.props

    if (success !== prevProps.success && success) {
      renderToastSuccessMsg(translate(success))

      clearSuccessMessage()
    }

    if (error !== prevProps.error && error) {
      renderToastWarn(error)
    }
  }

  setRenderButtons = (value) => {
    this.setState({ renderButtons: value })
  }

  invertStates = () => {
    if (window.innerWidth > 768) {
      this.setState({ formVisible: true })
      this.setState({ tableVisible: true })
      return
    }

    let { formVisible, tableVisible } = this.state

    formVisible = !formVisible
    tableVisible = !tableVisible

    this.setState({ formVisible })
    this.setState({ tableVisible })

    if (formVisible) {
      const { resetEditMenuMissions } = this.props
      resetEditMenuMissions()
    }
  }

  handleFetchUsageConsumptionApprovers = (page) => {
    const {
      fetchUsageConsumptionApprovers,
      auth: { user },
    } = this.props

    fetchUsageConsumptionApprovers(user.dsToken, page)
  }

  handleSubmit = (params) => {
    const {
      update,
      auth: { user },
    } = this.props

    update(user.dsToken, { dsMissionList: params })
  }

  getMenuMission = (index) => {
    const { getMenuMission } = this.props

    getMenuMission(index)
  }

  delMenuMission = async (values) => {
    const {
      remove,
      auth: { user },
    } = this.props

    remove(user.dsToken, values).then(() =>
      this.setState({
        updateOptions: true,
      })
    )
  }

  renderNotification = () => {
    const { translate } = this.props
    return (
      <Notification
        className='notification-warning notification-warning-mission margin-top'
        message={translate('usage-consumption-approvers.missions-not-found')}
      />
    )
  }

  renderFieldsErrors = (fields) => (
    <li className='margin-left' key={fields.naField}>
      {fields.naField ? `${fields.naField}:` : ''} {fields.dsDetail}
    </li>
  )

  getOptions = () => {
    const { options } = this.props

    return options.map((option) => ({
      value: option.cdMission,
      label: option.dsMission,
    }))
  }

  render() {
    const { translate, error, menuMissions, pages, count, current, auth } =
      this.props

    const { tableVisible, formVisible, renderButtons } = this.state

    const initialValues = {}

    return (
      <section className='menu-mission'>
        <ContentHeader>
          {translate('usage-consumption-approvers.title')}
        </ContentHeader>

        <section>
          <div className='container-fluid'>
            {error && error.fields ? (
              <div className='margin-top margin-botton notification notification-warning'>
                {error.fields.map(this.renderFieldsErrors)}
              </div>
            ) : error ? (
              <div className='margin-top margin-botton notification notification-warning'>
                {error.message.dsMessage}
              </div>
            ) : (
              ''
            )}
          </div>

          <Row className='container-mobile container-flex'>
            {formVisible && (
              <Col xs={12} sm={12} md={3} className='show-fourth-on-mobile'>
                <ApproversEditForm
                  translate={translate}
                  onSubmit={this.handleSubmit}
                  initialValues={initialValues}
                  error={error}
                  auth={auth}
                  invertStates={this.invertStates}
                  options={this.getOptions()}
                />
              </Col>
            )}

            {tableVisible && (
              <Col xs={12} sm={12} md={9} className='show-first-on-mobile'>
                <legend className='ApproversTable'>
                  {translate('usage-consumption-approvers.added-mission-list')}
                </legend>

                {isEmpty(menuMissions) ? (
                  this.renderNotification()
                ) : (
                  <UsageConsumptionApproversTable
                    translate={translate}
                    menuMissions={menuMissions}
                    delMenuMission={this.delMenuMission}
                    renderButtons={renderButtons}
                    setRenderButtons={this.setRenderButtons}
                    onSubmit={this.handleSubmit}
                    user={auth.user}
                  />
                )}
              </Col>
            )}

            {pages > 1 && tableVisible && (
              <Col className='show-second-on-mobile align-center margin-top margin-bottom-double'>
                <div className='align-center'>
                  <Pagination
                    getPage={this.handleFetchUsageConsumptionApprovers}
                    pages={pages}
                    current={current}
                    count={count}
                  />
                </div>
              </Col>
            )}

            {tableVisible && !renderButtons && (
              <Col
                xs={12}
                md={12}
                className='hidden-button show-third-on-mobile margin-bottom'
              >
                <button
                  role='button'
                  type='button'
                  onClick={this.invertStates}
                  display='none'
                  className='button button-primary button-full'
                >
                  {translate('mission.add-new-mission')}
                </button>
              </Col>
            )}
          </Row>
        </section>
        <ToastContainer newestOnTop />
      </section>
    )
  }
}

const mapStateToProps = ({
  usageConsumptionApproversReducer,
  paginateReducer,
}) => ({
  menuMissions: usageConsumptionApproversReducer.list.records,
  options: usageConsumptionApproversReducer.list.options,
  updated: usageConsumptionApproversReducer.edit.updated,
  removed: usageConsumptionApproversReducer.edit.removed,
  error: usageConsumptionApproversReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
  success: usageConsumptionApproversReducer.success,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(usageConsumptionApproversActions, dispatch)

const UsageConsumptionApproversTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(UsageConsumptionApproversContainer)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsageConsumptionApproversTranslated)

export { UsageConsumptionApproversContainer as UsageConsumptionApprovers }
